<template>
    <div>
        <a href="#"
            @click.prevent="is_checked=!is_checked"
            class="text-gray-500 flex flex-row"
            :class="{'text-gray-700':is_checked,
            'justify-end':align=='right',
            'justify-center':align=='center'}">
            <slot name="title"></slot>
            <vue-feather v-if="is_checked"
                type="chevron-up" class="w-4 h-4 ml-1 self-center"></vue-feather>
            <vue-feather v-else
                type="chevron-down" class="w-4 h-4 ml-1 self-center"></vue-feather>
        </a>
        <div v-show="is_checked"
            class="text-gray-600 text mt-3">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['update'],
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            default: "left",
        },
    },
    data() {
        return {
            is_checked: this.checked
        }
    },
    methods: {
        toggle: function() {
            this.is_checked = !this.is_checked
            this.$emit("update", !this.is_checked);
        }
    },
}
</script>

